var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component)?_c(_vm.component,{tag:"component",attrs:{"paginationData":_vm.paginationData,"itemData":_vm.itemData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }